import axios from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class NumberingServices {
  async getAll(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/numbering/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const numberingServices = new NumberingServices()
